import React, { useState } from 'react'
//import { useAuth } from '../../../../providers/AuthContext';
import { TableIcons } from '../../../../constants/tableIcons';
import MaterialTable from '@material-table/core';
import _ from 'lodash';

/*
props.userColumnKey   for use in user settings key that gets and changes user settings

userSettings[props.userColumnKey] === [{key: x, hidden: x}, {}]

*/
const CustomMaterialTable = (props) => {
    //throw errors for wrong shit
        //passing data that wont be used
            //props.onChangeColumnHidden
            //props.onColumnDragged
        //missing data
              //props.columns key required for each
              //props.tableKey required
              //
        //column field name uuid (is an internal name for mateial table which breaks sorting)

    //const { userSettings, updateUserSettings } = useAuth();
    
    const [internalColumns, 
        //setInternalColumns
    ] = useState( 
        // userSettings[props.tableKey] 
        // ? userSettings[props.tableKey].map((column) => { return (props.columns.find(x=> x.key === column.key)) }) 
        // : 
        props.columns 
    );

    // //FOR TESTING 
    // useEffect(() => {
    //     console.log('internalColumns', internalColumns)
    //     //console.log('userSettings', userSettings)
    // }, [internalColumns])

    // const handleChangeColumnHidden = (column, hidden) => {
    //     // let columnSettingsContainer = userSettings[props.tableKey] ? _.cloneDeep(userSettings[props.tableKey]) : props.columns.map(column => { return({key: column.key}) });
    //     // columnSettingsContainer[columnSettingsContainer.findIndex(x=> x.key === column.key)].hidden = hidden;
    //     // console.log('columnSettingsContainer hidden', columnSettingsContainer)
    //     // updateUserSettings(props.tableKey, columnSettingsContainer)

    //     // let columnContainer = _.cloneDeep(internalColumns)
    //     // columnContainer[columnContainer.find(x=> x.key === column.key)].hidden = hidden;
    //     // console.log('columnContainer hidden', columnContainer)
    //     // setInternalColumns(columnContainer)
    // }

    // const handleColumnDragged = (sourceIndex, destinationIndex) => {
    //     console.log('sourceIndex, destinationIndex', sourceIndex, destinationIndex)

    //     //console.log('internalColumns', internalColumns)

    //     // let columnSettingsContainer = userSettings[props.tableKey] 
    //     //     ? _.cloneDeep(userSettings[props.tableKey]) 
    //     //     //if setting doesnt exist
    //     //     : props.columns.map(column => { return({key: column.key, hidden: column.hidden || false}) });

    //     //let columnContainer = _.cloneDeep(internalColumns)

    //     // console.log('columnContainer', columnContainer)
    //     // console.log('columnSettingsContainer', columnSettingsContainer)
    //     //columnSettingsContainer.splice(destinationIndex, 0, columnSettingsContainer.splice(sourceIndex, 1)[0]);
    //     //columnContainer.splice(destinationIndex, 0, columnContainer.splice(sourceIndex, 1)[0]);
    //     //console.log('columnContainer', columnContainer)
    //     //setInternalColumns(columnContainer)

    //     // // columnSettingsContainer.splice(destinationIndex, 0, item1)
    //     // // columnSettingsContainer.splice(sourceIndex, 1)
    //     // updateUserSettings(props.tableKey, columnSettingsContainer)

    //     // let columnContainer = _.cloneDeep(internalColumns)
    //     // let item2 = _.cloneDeep(columnContainer[sourceIndex])
    //     // columnContainer.splice(destinationIndex, 0, item2)
    //     // columnContainer.splice(sourceIndex, 1)
    //     // setInternalColumns(columnContainer)
    // }

    return (
        <>
            <MaterialTable
                key={props.key}
                actions={props.actions}
                options={props.options}
                tableRef={props.tableRef}
                data={props.data}
                title={props.title}
                isLoading={props.loading}
                style={props.style}
                components={props.components}
                localization={props.localization}
                detailPanel={props.detailPanel}
                editable={props.editable}

                icons={TableIcons}

                onRowClick={props.onRowClick}
                onGroupRemoved={props.onGroupRemoved}
                onSelectionChange={props.onSelectionChange}
                onTreeExpandChange={props.onTreeExpandChange}
                parentChildData={props.parentChildData}

                //also user setting? maybe down the road
                onOrderChange={props.onOrderChange}

                //could all be handled here with dynamic session storage naming ex {`${[props.tableKey]}SeachValue`}
                onChangePage={props.onChangePage}
                onChangeRowsPerPage={props.onChangeRowsPerPage}
                onSearchChange={props.onSearchChange}
                onPageChange={props.onPageChange}
                onRowsPerPageChange={props.onRowsPerPageChange}
                
                //user settings? shouldnt be any props, all column data handled here
                columns={internalColumns}
                //onChangeColumnHidden={(column, hidden) => { handleChangeColumnHidden(column, hidden); }}
                //onColumnDragged={(sourceIndex, destinationIndex) => { handleColumnDragged(sourceIndex, destinationIndex); }}
            />
        </>
    )
}

export default CustomMaterialTable;